exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_object-gops.js
// module id = 488
// module chunks = 0